function getIntersects(state, event) {
    state.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    state.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    state.raycaster.setFromCamera(state.mouse, state.camera);
    return state.raycaster.intersectObject(state.mesh);
}

function getIntersectsKeypoints(state, event) {
    state.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    state.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    state.raycaster.setFromCamera(state.mouse, state.camera);

    // Get all keypoint spheres from the scene
    const keypointMeshes = state.scene.children.filter((child) =>
        child.name?.startsWith("keypoint-point-")
    );
    return state.raycaster.intersectObjects(keypointMeshes);
}

export { getIntersects, getIntersectsKeypoints };
